/**
 * Модуль конфигов для слайдеров. Получаем объект, у которого ключ должен быть равен ключу
 * переданному в дата-атрибут data-slider-settings="mainPageSlider" обертки с классом js-slider
 * Таким образом можно управлять всеми конфигами в этом файле
 */
itsoftApp.createModule("slidersSettings", function () {
    // Локальные переменные
    var module = this;

    module.sliderSettingsObject = {
        global: {
            simulateTouch: true,
            autoHeight: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            followFinger: true,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            speed: 500
        },

        mainArticlesSlider: {
            slidesPerView: 1,
            spaceBetween: 20,
            followFinger: true,
            autoHeight: false,
            watchOverflow: true,
            simulateTouch: true,
            navigation: {
                nextEl: '.main-articles__slider .button--next',
                prevEl: '.main-articles__slider .button--prev',
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                },

                1024: {
                    slidesPerView: 3,
                    spaceBetween: 21,
                }
            },
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            a11y: false,
            speed: 500
        },

        otherArticlesSlider: {
            simulateTouch: true,
            followFinger: true,
            slidesPerView: 1,
            spaceBetween: 20,
            autoHeight: false,
            watchOverflow: true,
            navigation: {
                nextEl: '.other-articles__slider .button--next',
                prevEl: '.other-articles__slider .button--prev',
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                }
            },
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            a11y: false,
            speed: 500
        },
    };
});